(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-hub"] && !Shopify.designMode) return;
  try {
    
  (()=>{const connect=hub=>{if(!hub||hub.dataset.faqConnected==='true')return;const input=hub.querySelector('[data-faq-search]'),status=hub.querySelector('[data-faq-status]'),items=[...hub.querySelectorAll('[data-faq-item]')],groups=[...hub.querySelectorAll('[data-faq-group]')];if(!input)return;hub.dataset.faqConnected='true';input.addEventListener('input',()=>{const query=input.value.trim().toLowerCase();let visible=0;items.forEach(item=>{const match=!query||item.textContent.toLowerCase().includes(query);item.hidden=!match;if(match)visible+=1});groups.forEach(group=>{group.hidden=![...group.querySelectorAll('[data-faq-item]')].some(item=>!item.hidden)});status.textContent=query?`${visible} ${visible===1?'answer':'answers'} found`:''})};document.querySelectorAll('[data-faq-hub]').forEach(connect);document.addEventListener('shopify:section:load',event=>connect(event.target.querySelector?.('[data-faq-hub]')));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (()=>{const connect=footer=>{const button=footer?.querySelector('[data-privacy-preferences]');if(!button||button.dataset.connected==='true')return;const bind=()=>{const show=window.Shopify?.customerPrivacy?.privacyBanner?.showPreferences;if(typeof show!=='function')return false;button.dataset.connected='true';button.hidden=false;button.addEventListener('click',()=>show());return true;};if(!bind())document.addEventListener('shopifyCustomerPrivacyApiLoaded',bind,{once:true});};document.querySelectorAll('[data-clean-footer]').forEach(connect);document.addEventListener('shopify:section:load',event=>connect(event.target.querySelector?.('[data-clean-footer]')));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-award-paths"] && !Shopify.designMode) return;
  try {
    
  function initOccasionEditor(root){if(!root||root.dataset.ready==='true')return;root.dataset.ready='true';const tabs=[...root.querySelectorAll('[data-occasion-tab]')];const panels=[...root.querySelectorAll('[data-occasion-panel]')];if(!tabs.length||tabs.length!==panels.length)return;const activate=(index,focusTab=false)=>{tabs.forEach((tab,i)=>{const active=i===index;tab.classList.toggle('is-active',active);tab.setAttribute('aria-selected',String(active));tab.setAttribute('tabindex',active?'0':'-1')});panels.forEach((panel,i)=>{const active=i===index;panel.classList.toggle('is-active',active);panel.setAttribute('aria-hidden',String(!active))});if(focusTab)tabs[index]?.focus()};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(index));tab.addEventListener('keydown',event=>{let nextIndex=null;if(event.key==='ArrowRight')nextIndex=(index+1)%tabs.length;if(event.key==='ArrowLeft')nextIndex=(index-1+tabs.length)%tabs.length;if(event.key==='Home')nextIndex=0;if(event.key==='End')nextIndex=tabs.length-1;if(nextIndex===null)return;event.preventDefault();activate(nextIndex,true)})})}document.querySelectorAll('[data-occasion-editor]').forEach(initOccasionEditor);document.addEventListener('shopify:section:load',event=>initOccasionEditor(event.target.querySelector?.('[data-occasion-editor]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urgent-whatsapp-tracking"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.location.pathname !== '/pages/same-day-and-next-day-cakes') return;

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;

    let destination;
    try { destination = new URL(link.href, window.location.origin); } catch (_) { return; }
    if (!/(^|\.)wa\.me$|(^|\.)whatsapp\.com$|(^|\.)api\.whatsapp\.com$/i.test(destination.hostname)) return;

    const payload = {
      page_path: window.location.pathname,
      destination: 'whatsapp',
      cta_location: link.closest('.same-day-hero') ? 'hero' : (link.closest('.same-day-final') ? 'final' : 'other'),
      cta_text: String(link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80)
    };

    try {
      const result = window.Shopify?.analytics?.publish?.('anges_cro:urgent_whatsapp_click', payload);
      result?.catch?.(() => {});
    } catch (_) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'urgent_whatsapp_click', payload);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'urgent_whatsapp_click', ...payload });
      }
    } catch (_) {}
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-collection-redesign"]) return;
  try {
    
const initWeddingIssue = (root) => {
  const cards = Array.from(root.querySelectorAll('[data-wedding-product]'));
  const styleButtons = Array.from(root.querySelectorAll('[data-wedding-style]'));
  const showAll = root.querySelector('[data-show-all]');
  let activeStyle = '';
  let expanded = false;

  const render = () => {
    cards.forEach((card) => {
      const styleOk = !activeStyle || (card.dataset.styles || '').split(/\s+/).includes(activeStyle);
      const initialOk = expanded || activeStyle || card.dataset.defaultHidden !== 'true';
      card.hidden = !(styleOk && initialOk);
    });
    if (showAll) showAll.hidden = expanded || Boolean(activeStyle);
  };

  styleButtons.forEach((button) => button.addEventListener('click', () => {
    activeStyle = button.dataset.weddingStyle || '';
    expanded = true;
    styleButtons.forEach((item) => {
      const active = (item.dataset.weddingStyle || '') === activeStyle;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    render();
  }));

  showAll?.addEventListener('click', () => {
    expanded = true;
    render();
  });

  render();
};
document.querySelectorAll('[data-wedding-collection]').forEach(initWeddingIssue);

  } catch(e) { console.error(e); }
})();
})();
